const removeWeirdCharacters = (value) => {
    if (value.includes('&#039;')) {
        value = value.replace(/&#039;/g, "'");
    }
    if (value.includes('&amp;')) {
        value = value.replace(/&amp;/g, '&');
    }
    return value;
}

export const extractCurrentEpisodeFromAirtimeResponse = (shows, defaultEpisodeName) => {
    if (shows) {
        const {current, next} = shows;
        const nextEpisodeName = next.length > 0 ? next.shift().name : defaultEpisodeName;
        const currentEpisodeName = current !== null ? current.name : defaultEpisodeName;
        const episodeName = currentEpisodeName.includes('Movement Ident') ? nextEpisodeName : currentEpisodeName;
        return removeWeirdCharacters(episodeName);
    } else {
        return "";
    }
}

export const extractNextEpisodeFromAirtimeResponse = (shows, defaultEpisodeName) => {
    if (shows) {
        const {next} = shows;
        if (next.length) {
            const nextEpisodeName = next.shift().name;
            const episodeName = nextEpisodeName.includes('Movement Ident') ? defaultEpisodeName : nextEpisodeName;
            return removeWeirdCharacters(episodeName);
        }
    } else {
        return "";
    }
}